<script lang="ts">
    import Module from "../../application/SyllabusManager/models/Module.ts";
    import ModalElement from "./ModalElement.svelte";
    import {_} from "svelte-i18n";
    import {writable} from "svelte/store";

    export let module: Module;

    $: data = writable(module);
</script>

<div class="card p-5">
    <div class="title">{$data.nameHu}</div>
    <ModalElement lead={$_('infoCard.credits')} text="{$data.credits}"/>
    <ModalElement lead={$_('infoCard.exams')} text="{$data.exams}"/>
    <ModalElement lead={$_('infoCard.midterms')} text="{$data.midterms}"/>
    <ModalElement lead={$_('infoCard.lectures')} text="{$data.lectures}"/>
    <ModalElement lead={$_('infoCard.practices')} text="{$data.practices}"/>
    <ModalElement lead={$_('infoCard.lab')} text="{$data.labPractices}"/>
</div>